import React from 'react';
import styled from 'styled-components';

import AttributesListItem from './AttributesListItem';

export default function AttributesList(props) {
    const { data, handleEditAttribute, handleDeleteAttribute } = props;

    return (
        <Wrapper className="AttributesList">
            {data.map((item) => (
                <AttributesListItem
                    key={item.attributeId}
                    handleOnEditAttribute={handleEditAttribute}
                    handleOnDeteleAttribute={handleDeleteAttribute}
                    {...item}
                />
            )
            )}
        </Wrapper>
    );
}

const Wrapper = styled.section`
    display: block;

    > section:not(:last-child) {
        border-bottom: var(--px-1) solid var(--neutrals-200);
    }
`;
